// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Aa-Pb","card_header":"Card_card_header__b18Aw","title":"Card_title__JR3tE"};